import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client'
import { act } from '../_store/act.module';
import { agreement } from '../_store/agreement.module';
import { config } from '../_helpers/config';
let stompClient = null;
let mainConfig = config.apiUrl
let sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export function connectWebSocket() {
  if (!navigator.onLine) return

  const socket = new SockJS(`${mainConfig}ws?access_token=${localStorage.getItem("access_token")}`)
  stompClient = Stomp.over(socket);
  stompClient.subscribe = awaitDecorator(stompClient.subscribe)
  stompClient.connect({}, () => {
    stompClient.subscribe('/user/topic/notifications', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        act.mutations.setNotViewedActFromWebSocket(act.state, body)
      }
    });
    stompClient.subscribe('/user/topic/deleteNotification', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        act.mutations.deleteNotViewedActFromWebSocket(act.state, body)
      }
    });
    stompClient.subscribe('/user/topic/newAgreement', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        agreement.mutations.setNotViewedAgreementFromWebSocket(agreement.state, body)
      }
    });
    stompClient.subscribe('/user/topic/deleteNewAgreement', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        agreement.mutations.deleteNotViewedAgreementFromWebSocket(agreement.state, body)
      }
    });
    stompClient.subscribe('/user/topic/changeAgreementEditable', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        agreement.mutations.changeAgreementEditable(agreement.state, body)
      }
    });
  }, (error) => {
    console.error('WebSocket error:', error);
  });

  socket.onclose = () => {
    setTimeout(() => {
      connectWebSocket()
    }, 30000)
  }
}
let awaitDecorator = (f) => {
  return async function () {
    if (stompClient.connected) return f.apply(this, arguments)
    await sleep(300)
    return f.apply(this, arguments)
  }
}
export function disconnectWebSocket() {
  if (stompClient !== null) {
    stompClient.disconnect();
  }
}